import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Big from "big.js";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";

import {
  Page,
  Loadable,
  DataTable,
  ViewSaleButton,
  Fab,
  SaleStatusSemaphore,
  InfoTooltip
} from "components/support";

import { SaleStatus } from "core/enum";

import styles from "./styles";
import Filter from "./filter";
import SummaryCard from "./summary-card";

import { colors, Icon } from "assets";
import { fn } from "util";

class CustomerSalesReportView extends Component {
  saleConfig = {
    identifier: "id",
    columns: [
      {
        accessor: "id",
        show: false
      },
      {
        accessor: "activated_at",
        type: "datetime",
        align: "center",
        Header: "Data"
      },
      {
        id: "number",
        Header: "Documento",
        Cell: props => (
          <ViewSaleButton
            sale={{
              uuid: props.row._original.sale_uuid,
              document_number: props.row._original.number,
              document: {
                type: props.row._original.type,
                serie: props.row._original.serie,
                number: props.row._original.number
              },
              ...props.row._original
            }}
          />
        )
      },
      {
        accessor: "status",
        Header: "Status",
        type: "enum",
        align: "center",
        params: { enum: SaleStatus },
        Cell: props => (
          <SaleStatusSemaphore
            status={props.row._original.status}
            description={props.row._original.sefaz_description}
            code={props.row._original.sefaz_code}
            type={props.row._original.type}
          />
        )
      },
      {
        id: "revenues_value",
        type: "money",
        accessor: customerSummary => customerSummary.revenues_value,
        Header: "Faturamento",
        align: "right"
      },
      {
        id: "costs_value",
        type: "money",
        accessor: customerSummary => customerSummary.costs_value,
        Header: (
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Custos
            <InfoTooltip hint="Não são considerados os custos dos opcionais." />
          </span>
        ),
        align: "right"
      },
      {
        id: "profit",
        accessor: "profit",
        Header: "Lucro Bruto",
        align: "right",
        Cell: props => this.customerProfit(props.row._original)
      }
    ]
  };

  customerConfig = {
    identifier: "id",
    columns: [
      {
        id: "customer_name",
        accessor: "customer_name",
        Header: "Cliente",
        align: "left",
        Cell: props => this.customerButton(props)
      },
      {
        accessor: "sales_count",
        Header: "Quantidade de Compras",
        align: "right"
      },
      {
        id: "revenues_value",
        type: "money",
        accessor: customerSummary => customerSummary.revenues_value,
        Header: "Faturamento",
        align: "right"
      },
      {
        id: "costs_value",
        type: "money",
        accessor: customerSummary => customerSummary.costs_value,
        Header: (
          <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            Custos
            <InfoTooltip hint="Não são considerados os custos dos opcionais." />
          </span>
        ),
        align: "right"
      },
      {
        id: "profit",
        accessor: "profit",
        Header: "Lucro Bruto",
        align: "right",
        Cell: props => this.customerProfit(props.row._original)
      }
    ]
  };

  customerButton(props) {
    const { presenter } = this.props;
    const uuid = props.row._original.customer_uuid;
    return (
      <p
        onClick={() =>
          presenter.onSelectCustomerButton(props, uuid, props.value)
        }
      >
        {" "}
        {props.value || "Cliente não Identificado"}
      </p>
    );
  }

  customerProfit({ profit, costs_value, revenues_value }) {
    let relativeProfit, absoluteProfit;
    let profitInPercentage = revenues_value !== 0 ? profit / revenues_value : 0;
    relativeProfit = Big(profitInPercentage)
      .times(100)
      .toFixed(2);
    absoluteProfit = fn.centsToReal(profit);

    return (
      <div>
        {`R$ ${absoluteProfit}`}
        {costs_value !== 0 && (
          <span style={styles.profitChip}>{relativeProfit}%</span>
        )}
      </div>
    );
  }

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      summary,
      customerSearchOptions,
      customer,
      mode,
      customerSelectedDataTable
    } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Vendas por Cliente
        </Typography>

        <Filter
          loading={loading}
          filters={filters}
          customer={customer}
          customerSearchOptions={customerSearchOptions}
          onSelectCustomer={customer => presenter.onSelectCustomer(customer)}
          customerSelectedDataTable={customerSelectedDataTable}
          onChange={filters => presenter.onFilterChange(filters)}
        />

        <Row>
          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              value={summary.total_revenues}
              label="Faturamento Total"
              tooltip="Inclui faturamento dos opcionais."
            />
          </Col>

          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              value={summary.total_costs}
              label="Custos"
              tooltip="Não são considerados os custos dos opcionais."
            />
          </Col>

          <Col xs={12} md>
            <SummaryCard
              loading={loading}
              revenues={summary.total_revenues}
              value={summary.profit}
              label="Lucro Bruto"
            />
          </Col>
        </Row>

        <Loadable loading={loading}>
          <Paper elevation={1}>
            <DataTable
              manual
              defaultSorted={[
                {
                  id: order.field,
                  desc: order.direction === "DESC"
                }
              ]}
              filterable={false}
              resultSet={results}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.page}
              config={
                mode === "customer" ? this.customerConfig : this.saleConfig
              }
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
            />
          </Paper>
        </Loadable>

        {this.downloadButton()}
      </Page>
    );
  }
}

export default CustomerSalesReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/customer-sales-report/view.jsx